import { render, staticRenderFns } from "./SparepartsArchive.vue?vue&type=template&id=0adf2f59"
import script from "./SparepartsArchive.vue?vue&type=script&lang=js"
export * from "./SparepartsArchive.vue?vue&type=script&lang=js"
import style0 from "./SparepartsArchive.vue?vue&type=style&index=0&id=0adf2f59&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports